export default {
  setProperty(state, { payload, property }) {
    state[property] = payload;
  },

  setEarningsProperty(state, { payload, property }) {
    state.earnings[property] = payload;
  },

  setGeoCodedData(state, payload) {
    state.geo_coded_sales_location.push(payload);
  },

  setTopRegions(state, payload) {
    if (payload === 'NG-LA') {
      const data = state.top_states.filter(item => item.state === 'Lagos');
      state.top_regions = data[0].top_region;
    } else {
      const data = state.top_states.filter(item => item.state === 'Oyo');
      state.top_regions = data[0].top_region;
    }
  },
};
